import { render, staticRenderFns } from "./BankEdit.vue?vue&type=template&id=697550cf&scoped=true"
import script from "./BankEdit.vue?vue&type=script&lang=ts"
export * from "./BankEdit.vue?vue&type=script&lang=ts"
import style0 from "./BankEdit.vue?vue&type=style&index=0&id=697550cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697550cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('697550cf')) {
      api.createRecord('697550cf', component.options)
    } else {
      api.reload('697550cf', component.options)
    }
    module.hot.accept("./BankEdit.vue?vue&type=template&id=697550cf&scoped=true", function () {
      api.rerender('697550cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bank/BankEdit.vue"
export default component.exports